/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Inject, Injectable} from '@angular/core';
import {MarkupBuilder} from '../interfaces/MarkupBuilder';
import {ExtraChargeType} from '../interfaces/ExtraChargeType';
import {MarkupBuilderToken} from '../shared.module';

@Injectable({
  providedIn: 'root'
})
export class MarkupService {
  markupBuilderMap = new Map<ExtraChargeType, MarkupBuilder>();

  constructor(@Inject(MarkupBuilderToken) markupBuilders: MarkupBuilder[]) {
    markupBuilders.forEach((markupBuilder: MarkupBuilder) => this.markupBuilderMap.set(markupBuilder.getType(), markupBuilder));
  }

  getMarkupBuilder(type: ExtraChargeType): MarkupBuilder {
    return this.markupBuilderMap.has(type) ? this.markupBuilderMap.get(type) : null;
  }
}
